import React from 'react';
import { useTranslation } from 'react-i18next';
import { Image, FileText } from 'lucide-react';
import { getExpenseReceiptItems } from '@/utils/expenseDisplay';

export default function ExpenseReportReceipts({ report, className = '' }) {
  const { t } = useTranslation();
  const items = getExpenseReceiptItems(report);

  if (!items.length) return null;

  return (
    <div className={`p-3 bg-gray-50 rounded border ${className}`.trim()}>
      <h4 className="font-semibold text-sm mb-2 flex items-center gap-1">
        <Image className="w-4 h-4" />
        {t('admin_tickets_receipts', { count: items.length })}
      </h4>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
        {items.map((item, idx) => (
          <div
            key={item.id || idx}
            className="border rounded overflow-hidden bg-white shadow-sm hover:shadow-md transition-shadow"
          >
            {item.isPdf ? (
              <a
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-col items-center justify-center h-32 p-2 text-blue-700 hover:bg-blue-50"
              >
                <FileText className="w-10 h-10 mb-1" />
                <span className="text-xs font-medium text-center">{t('admin_expense_receipt_pdf')}</span>
              </a>
            ) : (
              <img
                src={item.url}
                alt={t('admin_ticket_label', { n: idx + 1 })}
                className="w-full h-32 object-cover cursor-pointer hover:opacity-80"
                onClick={() => window.open(item.url, '_blank')}
              />
            )}
            <div className="p-1 text-center text-[10px] text-gray-600">
              {t('admin_ticket_label')} {idx + 1}
              {item.type ? ` · ${item.type}` : ''}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
